import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DateRendererComponent } from "./date-renderer.component";
import { LinkRendererComponent } from "./link-renderer.component";
import { DownloadRendererComponent } from "./download-renderer.component";
import { IconsModule } from "@va/core-library/icons";
import { PrintRendererComponent } from "./print-renderer.component";
import { AnalystRendererComponent } from "./analyst-renderer.component";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { SharedModule } from "../shared/shared.module";
import { IconLinkRendererComponent } from "./icon-link-renderer.component";
import { ReportingViewLinkRendererComponent } from "./reporting-view-link-renderer.component";
import { RouterModule } from "@angular/router";
import { ReportingModelRendererComponent } from "./reporting-model-renderer.component";
import { MultiIconRendererComponent } from "./multi-icon-renderer.component";
import { AlertGridActionRendererComponent } from "./alert-grid-action-renderer.component";
import { CheckboxRendererComponent } from "./checkbox-renderer.component";
import { FormsModule } from "@angular/forms";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";

@NgModule({
  declarations: [
    DateRendererComponent,
    LinkRendererComponent,
    DownloadRendererComponent,
    PrintRendererComponent,
    AnalystRendererComponent,
    IconLinkRendererComponent,
    ReportingViewLinkRendererComponent,
    ReportingModelRendererComponent,
    MultiIconRendererComponent,
    AlertGridActionRendererComponent,
    ReportingModelRendererComponent,
    CheckboxRendererComponent,
  ],
  imports: [
    CommonModule,
    IconsModule,
    NzToolTipModule,
    NzSpinModule,
    NzPopoverModule,
    NzCheckboxModule,
    SharedModule,
    FormsModule,
    RouterModule,
    NzSpinModule,
  ],
  exports: [
    DateRendererComponent,
    LinkRendererComponent,
    DownloadRendererComponent,
    PrintRendererComponent,
    AnalystRendererComponent,
    IconLinkRendererComponent,
    ReportingViewLinkRendererComponent,
    ReportingModelRendererComponent,
    MultiIconRendererComponent,
    AlertGridActionRendererComponent,
    ReportingModelRendererComponent,
    CheckboxRendererComponent,
  ],
})
export class DataCellRenderersModule {}
